import axios from "axios";
import React, { Component } from "react";
import Modal from "react-bootstrap/Modal";
import FeatherIcon from "feather-icons-react";
import { toast } from "react-toastify";
class ProfileForm extends Component {
  state = {
    id: null,
    profile: "",
    error: "",
    profilepermissions: [],
    title: "",
    permissionId: [],
    permissions: [],
    btn: false,
  };

  handleInput = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  edit = () => {
    this.form();
  };

  form = () => {
    const formData = this.props.formData;

    const profilepermissions = formData ? formData.profilepermissions || [] : [];
    const permissionId = profilepermissions.map((item) => item.permissionId);

    this.setState(
      {
        id: formData ? formData.id : null,
        profile: formData ? formData.profile : "",
        title: formData ? "Modifier le profil utilisateur" : "Ajouter un profil utilisateur",
        profilepermissions,
        permissionId,
        error: "",
        btn: false,
      },
      () => this.permissions()
    );
  };

  async permissions() {
    const permissions = await axios.get("permissions");

    if (permissions.status === 200) {
      this.setState({
        permissions: permissions.data,
      });
    }
  }

  handleInputPermission = (e) => {
    const permissionId = e.target.name;
    const checked = e.target.checked;

    this.setState((prevState) => ({
      permissionId: checked
        ? [...new Set([...prevState.permissionId, permissionId])]
        : prevState.permissionId.filter((id) => String(id) !== String(permissionId)),
    }));
  };

  storeProfile = () => {
    this.setState({ btn: true });

    const permissionId = this.state.permissionId.map((id) => ({
      permissionId: id,
    }));

    const data = {
      profile: this.state.profile,
      model: this.props.model,
      permissionId,
    };

    const request = this.state.id
      ? axios.put("profiles/" + this.state.id, data)
      : axios.post("profiles", data);

    request
      .then((response) => {
        this.setState({ btn: false });
        this.props.showModal();

        toast(response?.data?.msg, {
          theme: "light",
          style: { backgroundColor: "blue", color: "white" },
        });
      })
      .catch((error) => {
        this.setState({
          error: error.response?.data?.msg || "Une erreur est survenue",
          btn: false,
        });

        toast(error.response?.data?.msg, {
          theme: "light",
          style: { backgroundColor: "red", color: "white" },
        });
      });
  };

  delete = (profileId) => {
    axios
      .delete("profiles/" + profileId)
      .then((response) => {
        this.props.showModal();
        toast(response?.data?.msg, {
          theme: "light",
          style: { backgroundColor: "blue", color: "white" },
        });
      })
      .catch((error) => {
        toast(error.response?.data?.msg, {
          theme: "light",
          style: { backgroundColor: "red", color: "white" },
        });
      });
  };

  handleCheck(val) {
    const permissions = localStorage.getItem("permissions")
      ? JSON.parse(localStorage.getItem("permissions"))
      : [];

    return permissions.some((item) => val === item.permission);
  }

  render() {
    const permissionItems = this.state.permissions.map((permission) => (
      <label
        key={permission.id}
        htmlFor={`permission-${permission.id}`}
        className="m-1 d-inline-flex align-items-center border rounded-pill px-3 py-2 cursor-pointer"
      >
        <input
          type="checkbox"
          className="rounded me-2"
          name={permission.id}
          checked={this.state.permissionId.some((id) => String(id) === String(permission.id))}
          onChange={this.handleInputPermission}
          id={`permission-${permission.id}`}
        />

        <FeatherIcon icon="key" size={14} className="text-primary me-2" />

        <span className="font-monospace fw-normal">{permission.permission}</span>
      </label>
    ));

    return (
      <Modal
        show={this.props.isModal}
        onHide={this.props.showModal}
        size="lg"
        dialogClassName="student-form-dialog"
        contentClassName="student-form-modal student-form-modal--compact"
        onEntered={this.edit}
        backdrop="static"
      >
        <Modal.Header>
          <div className="student-form__heading">
            <span className="student-form__heading-icon">
              <FeatherIcon icon="shield" size="20" />
            </span>

            <div>
              <span className="student-form__eyebrow">Profil utilisateur</span>
              <Modal.Title>{this.state.title}</Modal.Title>
            </div>
          </div>
        </Modal.Header>

        <Modal.Body className="row student-form__body" style={{ fontSize: 13 }}>
          {this.state.error && (
            <div className="col-12">
              <div className="student-form__alert" role="alert">
                <FeatherIcon icon="alert-circle" size={17} />
                <span>{this.state.error}</span>
              </div>
            </div>
          )}

          <div className="col-12 student-form__section-title">
            <span>
              <FeatherIcon icon="user-check" size={16} />
            </span>
            <div>
              <strong>Informations du profil</strong>
              <small>Nom du profil et permissions associées</small>
            </div>
          </div>

          <div className="col-12 mt-2">
            <div className="form-group has-icon-left">
              <label className="font-monospace fw-normal">
                Profil<span className="text-danger">*</span>
              </label>

              <div className="position-relative mt-1">
                <input
                  type="text"
                  className="form-control form-control-sm"
                  onChange={this.handleInput}
                  name="profile"
                  value={this.state.profile}
                />
              </div>
            </div>
          </div>

          <div className="col-12 student-form__section-title mt-3">
            <span>
              <FeatherIcon icon="lock" size={16} />
            </span>
            <div>
              <strong>Accès du profil {this.state.profile}</strong>
              <small>Sélectionnez les permissions autorisées pour ce profil</small>
            </div>
          </div>

          <div className="col-12 mt-2">
            <div className="input-group pt-2 flex-wrap">
              {permissionItems}
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer>
          {this.handleCheck("Supprimer profil") && this.state.id && (
            <button
              type="button"
              onClick={() => this.delete(this.state.id)}
              className="btn btn-light text-danger student-form__button me-auto"
            >
              <FeatherIcon icon="trash-2" size={16} /> Supprimer
            </button>
          )}

          <span className="student-form__footer-note">
            <FeatherIcon icon="info" size={14} /> Les permissions sélectionnées seront appliquées au profil
          </span>

          <button
            type="button"
            onClick={this.props.showModal}
            className="btn btn-light student-form__button"
          >
            <FeatherIcon icon="x" size={16} /> Fermer
          </button>

          <button
            type="button"
            onClick={this.storeProfile}
            disabled={this.state.btn}
            className="btn btn-primary student-form__button"
          >
            <FeatherIcon icon="check" size={16} />
            {this.state.btn ? "Enregistrement..." : "Sauvegarder"}
          </button>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default ProfileForm;